import { render } from "./PartnersBlock.vue?vue&type=template&id=58aafac2&scoped=true"
import script from "./PartnersBlock.vue?vue&type=script&lang=js"
export * from "./PartnersBlock.vue?vue&type=script&lang=js"

import "./PartnersBlock.vue?vue&type=style&index=0&id=58aafac2&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58aafac2"]])

export default __exports__